module.exports = __webpack_public_path__ + "static/media/weeds.623195dc.png";